//import axios from 'axios'
import axios from './axiosConfig'

export default {

/**
 * Sends the data entered by the user to the create Project Controller.
 *
 */
	async createProject(payload){
		
		
		return await axios({
				url: '/create/project', 
				data: JSON.parse(JSON.stringify(payload)),
				method: 'POST'
			});
	},
	async updateProject(payload){
		
		
		return await axios({
				url: '/update/project', 
				data: JSON.parse(JSON.stringify(payload)),
				method: 'POST'
			});
	},

/**
 * Receives the project data from the return project controller
 *
 */	
	async returnProjects(){
		return axios.post('/get/projects')
	    	.then(response => {
	  			return response.data;
		});
	},
	
	async returnFullProjectData(){
		return axios.post('/get/entire/data')
	    	.then(response => {
	  			return response.data;
		});
	},

	async createConfiguration(payload){
		
		
		return await axios({
				url: '/create/configuration', 
				data: JSON.parse(JSON.stringify(payload)),
				method: 'POST'
			});
	},
}